var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 4,
    viewBox: "0 0 24 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.71094L0 1.71094",
    stroke: "#FF8D28",
    strokeWidth: 3.42225,
    strokeDasharray: "6.84 6.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.71094L0 1.71094",
    stroke: "url(#paint0_linear_784_5527)",
    strokeWidth: 3.42225,
    strokeDasharray: "6.84 6.84"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_5527",
    x1: -8.37137,
    y1: 1.50712,
    x2: -8.37027,
    y2: 0.755515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CF101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientLine);
export default __webpack_public_path__ + "static/media/gradient_line.cf66b18cb7fbecc1ca3863411daa5942.svg";
export { ForwardRef as ReactComponent };